import { Box, useMediaQuery } from '@material-ui/core'
import React from 'react'
import UniversalTabs from '../../../elements/UniversalTabs'
import { useHistory, useLocation } from 'react-router-dom';
import theme from '../../../../theme';

export default function AdminPayoutsAndTaxFormsTabs() {
    const history = useHistory();
    const location = useLocation();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const tabs = [
        { label: "Payouts", value: "/admin-payouts" },
        { label: "Tax Forms", value: "/admin/tax-forms" },
    ];
    const tab = location.pathname.startsWith("/admin/tax-forms")
        ? "/admin/tax-forms"
        : "/admin-payouts";

    const handleTabChange = (value: string | number) => {
        if (value === "/admin/tax-forms") {
            history.push("/admin/tax-forms");
        } else {
            history.push("/admin-payouts");
        }
    };

    return (
        <>
            <Box
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: isMobile ? 0 : 40,
                    marginBottom: isMobile ? 0 : 32,
                    width: isMobile ? "100%" : "max-content"
                }}
            >
                <UniversalTabs
                    tabs={tabs}
                    value={tab}
                    onChange={handleTabChange}
                />
            </Box>
        </>
    )
}
